import { render, staticRenderFns } from "./TestComponents.vue?vue&type=template&id=3a2a613c"
import script from "./TestComponents.vue?vue&type=script&lang=js"
export * from "./TestComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports